// A TAB FROM BEFORE A DEPLOY (2026-10-20). Each build names its code by hash
// (/assets/<page>-<hash>.js) and a task serves only its own build. A tab
// opened before a deploy still names the old build's files, so once its task
// has gone (a deploy runs old and new side by side for about two and a half
// minutes, infra/alb.tf), opening a page the tab has not loaded yet asks the
// new task for a file it never had, and the page fails to load. One reload
// fetches the new build. Once a minute at most: a second failure that soon is
// a real one, left to the error boundary (components/ErrorBoundary.tsx).

const KEY = 'kalibrStaleBuildReloadAt';
const ONCE_MS = 60_000;
/** How each browser says a page's code could not be fetched, and Vite's own word for a stylesheet that could not. */
const STALE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

/** Does this error say a page's code (or its stylesheet) could not be fetched? */
export function isStaleChunk(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return STALE.test(message);
}

/** Reload the page for the new build, once a minute at most; true when it
 *  reloads. Without session storage it never reloads: a loop is worse than
 *  an error the boundary can show. */
export function reloadForNewBuild(now: number = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (now - last < ONCE_MS) return false;
    sessionStorage.setItem(KEY, String(now));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
